// extracted by mini-css-extract-plugin
export default {"bankAccAlign":"Classes_bankAccAlign__Ga1WA","equalHeightCard":"Classes_equalHeightCard__e1SVe","fundInvestment":"Classes_fundInvestment__xlVFI"};